import { FC, useEffect, useState } from "react";
import styles from "./ReferalCard.module.scss";
import { Avatar } from "../Avatar/Avatar";
import currencyIcon from '../../icons/currency-blue.png';
import { formatNumberWithSpaces } from "../../utils/numbers";
import { Ticket, TicketType } from "../TicketsPanel/Ticket";
import { ReferalProgress } from "./ReferalProgress/ReferalProgress";
import { useSelector } from "../../hooks";
import fragmentIcon from "../../icons/fragment.png";

export interface IReferal {
    firstName: string;
    lastName: string;
    username: string;
    reward: number;
    exp: number;
    avatar: string;
    winFragments: number;
}

interface IReceivedCount {
    tickets: number;
    fragments: number;
}

interface IReferalCardProps extends IReferal {}

export const ReferalCard: FC<IReferalCardProps> = ({ firstName, lastName, username, reward, exp, avatar, winFragments }) => {
    const milestones = useSelector(store => store.referals.milestones);
    const [receivedCount, setReceivedCount] = useState<IReceivedCount>({ tickets: 0, fragments: 0});

    useEffect(() => {
        const receivedCount = milestones
            .slice(0, milestones.filter(milestone => milestone.exp <= exp).length)
            .reduce((acc: IReceivedCount, milestone) => {
                acc.tickets += milestone.ticketsCount;
                acc.fragments += milestone.fragmentsCount ?? 0;
                return acc;
            }, { tickets: 0, fragments: 0 });

        setReceivedCount(receivedCount);
    }, [milestones, exp]); 
    
    const getFragmentItem = (count: number) => {
        return (
            <div className={styles.fragmentCont}>
                <img className={ styles.fragmentImage} src={ fragmentIcon } alt='fragment' />
                <span className={ styles.fragmentCount }>
                    {`${count} шт`}
                </span>
            </div>
        );
    }

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <Avatar name={firstName ?? lastName ?? username} url={avatar} />

                <span className={styles.name}>
                    { `${firstName ?? ''} ${lastName ?? ''}`.trim() ?? username }
                </span>
            </div>

            <div className={styles.income}>
                <span className={styles.incomeText}>Доход:</span>
                
                <div className={styles.amount}>
                    <img src={currencyIcon} alt="currency" />
                    <span>{formatNumberWithSpaces(reward)}</span>
                </div>
            </div>

            <div className={styles.experienceBox}>
                <div className={styles.experienceHeader}>
                    <span>Опыт друга</span>

                    <span className={styles.experienceCount}>
                        {formatNumberWithSpaces(exp)}
                    </span>
                </div>

                <div className={styles.receviedTitle}>Получено за друга::</div>

                <div className={styles.ticketInfo}>
                    <span>Билетов за опыт</span>
                    <Ticket type={'epicTickets' as TicketType} value={ receivedCount.tickets } postfix=' шт' context={'referal'} precission={0} />
                </div>                

                <div className={styles.ticketInfo}>
                    <span>Фрагментов за опыт</span>
                    { getFragmentItem(receivedCount.fragments) }
                </div>

                <div className={styles.ticketInfo}>
                    <span>10% с сертификата друга</span>
                    { getFragmentItem(winFragments) }
                </div>

                <ReferalProgress exp={exp} />
            </div>
        </div>
    );
};